/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_EditInputs */

const en_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const he_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עריכה`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Action_EditInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const action_edit = /** @type {((inputs?: Action_EditInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_EditInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_edit(inputs)
	return he_action_edit(inputs)
});